import { render, staticRenderFns } from "./PosViewComponent.vue?vue&type=template&id=2b617870&"
import script from "./PosViewComponent.vue?vue&type=script&lang=js&"
export * from "./PosViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports